<mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
<div class="spinner" *ngIf="loading">
	<mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>

<div class="mdc-layout-grid__inner">
	<div class="mdc-layout-grid__cell--span-12 header n126">
		<mat-icon class="mat-icon-rtl-mirror">ads_click</mat-icon>
		<h3>{{ locale.translations['ads']['ad']['n307'] }}</h3>
	</div>
	<div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet">
		<mat-radio-group [formControl]="socialOption">
			<mat-radio-button value="facebook">{{ locale.translations['ads']['ad']['n309'] }} {{ locale.translations['ads']['ad']['n308'] }}</mat-radio-button>
			<mat-radio-button value="instagram">{{ locale.translations['ads']['ad']['n310'] }} {{ locale.translations['ads']['ad']['n308'] }}</mat-radio-button>
			<mat-radio-button value="snapchat">{{ locale.translations['ads']['ad']['n311'] }} {{ locale.translations['ads']['ad']['n308'] }}</mat-radio-button>
			<mat-radio-button value="tiktok">{{ locale.translations['ads']['ad']['n312'] }} {{ locale.translations['ads']['ad']['n308'] }}</mat-radio-button>
		</mat-radio-group>
	</div>

	<div
		class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
		[hidden]="socialOption.value != 'facebook'"
	>
		<h6>{{ locale.translations['ads']['ad']['n313'] }}</h6>

		<div *ngFor="let item of resultsFb; let i = index">
			<div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
				<table class="table_social">
					<thead>
						<tr>
							<th colspan="5" class="subHeader">{{ item.name }}</th>
						</tr>
						<tr>
							<th *ngIf="i === 0" style="width: 22%">{{ locale.translations['ads']['ad']['n317'] }}</th>
							<th *ngIf="i === 0" style="width: 22%">{{ locale.translations['ads']['ad']['n318'] }}</th>
							<th *ngIf="i === 0" style="width: 22%">{{ locale.translations['ads']['ad']['n384'] }}</th>
							<th *ngIf="i === 0" style="width: 22%">{{ locale.translations['ads']['ad']['n385'] }}</th>
							<th *ngIf="i === 0" style="width: 12%">{{ locale.translations['ads']['ad']['n319'] }}</th>
						</tr>
					</thead>

					<tbody>
						<tr *ngFor="let value of item.values">
							<td style="width: 22%">{{ value.sharedCycles + '/' }} {{ value.totalCycles }}</td>
							<td style="width: 22%">{{ value.timeOn }}</td>
							<td style="width: 22%">{{ value.postreach }}</td>
							<td style="width: 22%">{{ value.likes }}</td>
							<td style="width: 12%">
								<a button href="{{ value.shareUrl }}" target="_blank">
									<img [src]="'/assets/favicon/facebook.svg' | s3Image" />
								</a>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>

	<div
		class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
		[hidden]="socialOption.value != 'instagram'"
	>
		<h6>{{ locale.translations['ads']['ad']['n314'] }}</h6>
		<div *ngFor="let item of resultsIg; let i = index">
			<div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
				<table class="table_social">
					<thead>
						<tr>
							<th colspan="3" class="subHeader">{{ item.name }}</th>
						</tr>
						<tr>
							<th style="width: 35%">{{ locale.translations['ads']['ad']['n317'] }}</th>
							<th style="width: 35%">{{ locale.translations['ads']['ad']['n318'] }}</th>
							<th style="width: 30%">{{ locale.translations['ads']['ad']['n319'] }}</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let value of item.values">
							<td style="width: 35%">{{ value.sharedCycles + '/' }} {{ value.totalCycles }}</td>
							<td style="width: 35%">{{ value.timeOn }}</td>
							<td style="width: 35%">
								<a button href="{{ value.shareUrl }}" target="_blank">
									<img [src]="'/assets/favicon/insta.svg' | s3Image" />
								</a>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>

	<div
		class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
		[hidden]="socialOption.value != 'snapchat'"
	>
		<h6>{{ locale.translations['ads']['ad']['n315'] }}</h6>
		<div *ngFor="let item of resultsSn; let i = index">
			<div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
				<table class="table_social">
					<thead>
						<tr>
							<th colspan="3" class="subHeader">{{ item.name }}</th>
						</tr>
						<tr>
							<th style="width: 35%">{{ locale.translations['ads']['ad']['n317'] }}</th>
							<th style="width: 35%">{{ locale.translations['ads']['ad']['n318'] }}</th>
							<th style="width: 30%">{{ locale.translations['ads']['ad']['n319'] }}</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let value of item.values">
							<td style="width: 35%">{{ value.sharedCycles + '/' }} {{ value.totalCycles }}</td>
							<td style="width: 35%">{{ value.timeOn }}</td>
							<td style="width: 35%">
								<a button href="{{ value.shareUrl }}" target="_blank">
									<img [src]="'/assets/favicon/snapchat-512.png' | s3Image" />
								</a>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>

	<div
		class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
		[hidden]="socialOption.value != 'tiktok'"
	>
		<h6>{{ locale.translations['ads']['ad']['n316'] }}</h6>
		<div *ngFor="let item of resultsTk; let i = index">
			<div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
				<table class="table_social">
					<thead>
						<tr>
							<th colspan="3" class="subHeader">{{ item.name }}</th>
						</tr>
						<tr>
							<th style="width: 35%">{{ locale.translations['ads']['ad']['n317'] }}</th>
							<th style="width: 35%">{{ locale.translations['ads']['ad']['n318'] }}</th>
							<th style="width: 30%">{{ locale.translations['ads']['ad']['n319'] }}</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let value of item.values">
							<td style="width: 35%">{{ value.sharedCycles + '/' }} {{ value.totalCycles }}</td>
							<td style="width: 35%">{{ value.timeOn }}</td>
							<td style="width: 35%">
								<a button href="{{ value.shareUrl }}" target="_blank">
									<img [src]="'/assets/favicon/Social-media_Tiktok-512.png' | s3Image" />
								</a>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</div>
